<template>
  <li class="base-action-list-item">
    <button
      :class="baseActionListButtonClasses"
      class="base-action-list-item__button"
      @click="$emit('click')"
    >
      <slot />
    </button>
  </li>
</template>

<script setup>
import { computed } from "vue";

defineEmits(["click"]);

const props = defineProps({
  type: {
    type: String,
    default: "secondary",
    validator: (value) => [
      "primary",
      "secondary",
      "success",
      "warning",
      "error",
      "danger",
      "info",
    ].includes(value),
  },
});

const baseActionListButtonClasses = computed(() => ({
  [`base-action-list-item__button--type-${props.type}`]: true,
}));
</script>

<style lang="scss">
@import "./base-action-list-item.scss";
</style>
